<template>
  <div>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-truck</v-icon>
          RESUMEN POR TRANSPORTISTA
          {{ new Date().addDays(-7).toISOString().split("T")[0] }}
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>

        <v-col cols="2" class="pt-4">
          <v-text-field
            class="pt-4"
            v-model="busNumGuia"
            label="Guia"
            append-icon="mdi-magnify"
            clearable
            @keyup.enter="cargarLista()"
            @click:append="cargarLista()"
          ></v-text-field>
          <!-- <v-autocomplete
            label="Guia"
            class="mt-6"
            v-model="busCabeceraId"
            :items="guiasCoord"
            item-text="NOM_GUIA"
            item-value="CABECERA_ID"
            @change="cargarLista()"
          >
          </v-autocomplete> -->
        </v-col>
        <v-col cols="2" class="pt-4">
          <v-select
            clearable
            class="pt-4"
            label="Periodo"
            :items="periodos"
            v-model="busPeriodo"
            @change="cambiarFechas()"
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-text-field
            v-model="busDesde"
            @click:append="cargarLista()"
            @keyup.enter="cargarLista()"
            @change="cargarLista()"
            clearable
            small
            type="date"
            append-icon="mdi-magnify"
            label="Desde"
            class="mt-5 mx-1"
          >
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-text-field
            v-model="busHasta"
            @click:append="cargarLista()"
            small
            @keyup.enter="cargarLista()"
            type="date"
            clearable
            @change="cargarLista()"
            append-icon="mdi-magnify"
            label="Hasta"
            class="mt-5 mx-1"
          >
          </v-text-field>
        </v-col>
        <!-- <v-col cols="3">
          <v-text-field
            type="date"
            v-model="fechaArriboEstimada"
            label="Fecha llegada estimada"
            class="mt-2 mb-0 pb-0"
          >
            <template v-slot:append>
              <v-btn
                icon
                title="Modificar fecha de llegada"
                @click="guardarFechaTransporte"
                ><v-icon left>mdi-content-save</v-icon></v-btn
              >
            </template>
          </v-text-field>
        </v-col> -->
        <!-- <v-col cols="3">
          <v-text-field
            class="mt-3 mb-0 pb-0"
            label="buscar"
            v-model="searchCargaBod"
          ></v-text-field>
        </v-col> -->
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-toolbar>
        <v-btn small color="blue" dark @click="exportarResumen()"
          ><v-icon left>mdi-file-excel</v-icon>Exportar</v-btn
        >
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="lista"
        :items-per-page="itemsPerPage"
        :search="searchCargaBod"
        :loading="loadingTable"
        class="elevation-1"
        v-model="itemsSel"
        hide-default-footer
      >
        <!-- <template v-slot:item.opcion="{ item }">
          <v-btn icon small color="green" @click="abrirDialogCargaDim(item)">
            <v-icon>mdi-move-resize</v-icon>
          </v-btn>

          <v-btn icon small color="red" @click="descargarEtiqueta(item)">
            <v-icon>mdi-file-pdf-box</v-icon>
          </v-btn>
        </template> -->
        <template v-slot:footer>
          <v-pagination
            class="mt-10"
            v-model="currentPage"
            :length="pageCount"
            @input="handlePageChange"
            total-visible="10"
          ></v-pagination>
        </template>
      </v-data-table>
    </v-card>

    <!-- dialogo carga dimensiones -->
    <v-dialog v-model="dialogCargaDim" max-width="700px">
      <v-card>
        <v-toolbar flat color="blue" height="40" dark>
          <v-card-title class="mx-0 mt-1 px-0">
            <v-icon class="mb-1" left>mdi-truck</v-icon>
            Datos cajas
          </v-card-title>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-form ref="formCargaBodega">
              <v-row>
                <v-col class="pt-2 pb-0" cols="12">
                  <v-text-field
                    tabindex="-1"
                    readonly
                    v-model="datosCargaDim.FINCA"
                    label="Finca"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12">
                  <v-text-field
                    tabindex="-1"
                    class="py-0"
                    readonly
                    v-model="datosCargaDim.CLIENTE_FINAL"
                    label="Cliente"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="3">
                  <v-text-field
                    tabindex="-1"
                    class="py-0"
                    readonly
                    v-model="datosCargaDim.TIPO_CAJA"
                    label="Tipo de caja"
                  >
                  </v-text-field>
                </v-col>

                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field
                    tabindex="-1"
                    class="py-0"
                    readonly
                    v-model="datosCargaDim.TRANSP_NOMBRE"
                    label="Transportista"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="3">
                  <v-text-field
                    tabindex="-1"
                    class="py-0"
                    readonly
                    v-model="datosCargaDim.FECHA_TRANSPORTE"
                    label="Fecha de transporte"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pb-0" cols="3">
                  <v-text-field
                    id="piezas"
                    ref="txtPiezas"
                    tabindex="0"
                    :rules="requiredRule"
                    v-model="datosCargaDim.PIEZAS"
                    label="Piezas"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="3">
                  <v-text-field
                    :rules="requiredRule"
                    v-model="datosCargaDim.ANCHO"
                    label="Ancho"
                    tabindex="1"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="3">
                  <v-text-field
                    :rules="requiredRule"
                    v-model="datosCargaDim.ALTO"
                    label="Alto"
                    tabindex="2"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="3">
                  <v-text-field
                    :rules="requiredRule"
                    v-model="datosCargaDim.LARGO"
                    label="Largo"
                    tabindex="3"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-center">
            <v-btn small color="primary" @click="guardarCargaDim">
              <v-icon>mdi-content-save</v-icon> Guardar
            </v-btn>
            &nbsp;&nbsp;
            <v-btn small @click="dialogCargaDim = !dialogCargaDim">
              <v-icon>mdi-cancel</v-icon> Cancelar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";

export default {
  name: "CargaBodega",
  data: () => ({
    headers: [
      { text: "FECHA ENTREGA", value: "FECHA_EST_ENTREGA" },
      { text: "CLIENTE", value: "CLIENTE_FINAL" },
      { text: "PIEZAS", value: "PIEZAS" },
      { text: "TRANSPORTISTA", value: "TRANSPORTISTA" },
      { text: "DIA", value: "DIA_TRANSP" },
    ],

    requiredRule: [(v) => !!v || "El campo es requerido"],
    emailRules: [
      (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Ingrese un Email válido",
    ],
    lista: [],

    options: {},
    periodos: [
      "HOY",
      "AYER",
      "MAÑANA",
      "PROXIMOS 2 DIAS",
      "PROXIMA SEMANA",
      "LA SEMANA PASADA",
      "ESTE MES",
    ],
    currentPage: 1,
    pageCount: 1,
    itemsPerPage: 20,
    busNumGuia: "",
    busDesde: new Date().toISOString().split("T")[0],
    busHasta: new Date().toISOString().split("T")[0],
    busPeriodo: "HOY",
    /*dialogTransportista: false,
    datosTransportista: {
      TRANSP_ID: "",
      TRANSP_NOMBRE: "",
      ACTIVO: 1,
    },*/

    dialogCargaDim: false,
    datosCargaDim: { FINCA: "", CLIENTE: "", CLIENTE_FINAL: "" },
    fechaArriboEstimada: "",

    nuevoTransp: false,
    busCabeceraId: "",
    search: "",

    guiasCoord: [],
    itemsSel: [],
    searchCargaBod: "",
  }),
  computed: {
    ...mapState("master", ["loadingTable", "user"]),
    ...mapGetters("access", [""]),
  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setMenu",
      "setLoadingTable",
      "setTitleToolbar",
    ]),
    ...mapActions("master", ["requestApi", "alertNotification"]),

    cambiarFechas() {
      if (this.busPeriodo == "HOY") {
        this.busDesde = new Date().toISOString().split("T")[0];
        this.busHasta = new Date().toISOString().split("T")[0];
        this.cargarLista();
      }
      if (this.busPeriodo == "AYER") {
        this.busDesde = new Date().addDays(-1).toISOString().split("T")[0];
        this.busHasta = new Date().addDays(-1).toISOString().split("T")[0];
        this.cargarLista();
      }
      if (this.busPeriodo == "MAÑANA") {
        this.busDesde = new Date().addDays(1).toISOString().split("T")[0];
        this.busHasta = new Date().addDays(1).toISOString().split("T")[0];
        this.cargarLista();
      }
      if (this.busPeriodo == "PROXIMOS 2 DIAS") {
        this.busDesde = new Date().addDays(0).toISOString().split("T")[0];
        this.busHasta = new Date().addDays(2).toISOString().split("T")[0];
        this.cargarLista();
      }
      if (this.busPeriodo == "PROXIMA SEMANA") {
        const date = new Date();
        const today = date.getDate();
        const currentDay = date.getDay();
        const newDate = date.setDate(today - currentDay + 7);

        this.busDesde = new Date(newDate).toISOString().split("T")[0];
        this.busHasta = new Date(newDate)
          .addDays(6)
          .toISOString()
          .split("T")[0];
        this.cargarLista();
      }
      if (this.busPeriodo == "LA SEMANA PASADA") {
        const date = new Date();
        const today = date.getDate();
        const currentDay = date.getDay();
        const newDate = date.setDate(today - currentDay - 7);

        this.busDesde = new Date(newDate).toISOString().split("T")[0];
        this.busHasta = new Date(newDate)
          .addDays(6)
          .toISOString()
          .split("T")[0];
        this.cargarLista();
      }
      if (this.busPeriodo == "ESTE MES") {
        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        this.busDesde = firstDay.toISOString().split("T")[0];
        this.busHasta = lastDay.toISOString().split("T")[0];
        this.cargarLista();
      }
    },
    validarEmail(email) {
      if (email == "") {
        return [true];
      }
      if (email == null) {
        return [true];
      }
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return ["Email inválido"];
      } else {
        return [true];
      }
    },

    cargarDatos() {
      this.setLoadingTable(true);
      this.setUrl("api/datos-carga-recibida");
      this.requestApi({
        method: "GET",
        data: {},
      })
        .then((res) => {
          //console.log(res);
          this.guiasCoord = res.data.guiasCoord;
          this.pageCount = 10;
        })
        .catch(() => {})
        .then(() => {
          this.setLoadingTable(false);
        });
    },
    cargarLista() {
      this.setLoadingTable(true);
      this.setUrl("api/resumen-carga-transportista");
      this.requestApi({
        method: "GET",
        data: {
          pageCount: this.pageCount,
          itemsPerPage: this.itemsPerPage,
          page: this.currentPage,
          busDesde: this.busDesde,
          busHasta: this.busHasta,
          busNumGuia: this.busNumGuia,
        },
      })
        .then((res) => {
          //console.log(res);
          this.lista = res.data.lista;
          this.pageCount = res.data.pageCount;
          this.totalItems = res.data.totalItems;
        })
        .catch(() => {})
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    abrirDialogCargaDim(item) {
      this.cargarDatosCargaDim(item);
      this.dialogCargaDim = true;
    },
    cargarDatosCargaDim(item) {
      this.setUrl("api/datos-carga-bodega");
      this.requestApi({
        method: "GET",
        data: {
          ID: item.ID,
        },
      }).then((res) => {
        this.datosCargaDim = res.data.datos_carga;
      });
    },
    exportarResumen() {
      this.setUrl("api/exportar-resumen-carga-transp");

      this.requestApi({
        method: "POST",
        data: {
          accion: "e",
          busDesde: this.busDesde,
          busHasta: this.busHasta,
          busNumGuia: this.busNumGuia,
        },
      }).then((res) => {
        let a = document.createElement("a");
        a.href =
          "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
          res.data.datos;
        a.download = res.data.archivo;
        a.click();
      });
    },

    handlePageChange() {
      this.cargarLista();
    },
    onkeyup(e) {
      if (e.altKey && e.keyCode == 67) {
        alert("CANCELAR");
        this.dialogCargaDim = false;
      }
      //G
      if (e.altKey && e.keyCode == 71) {
        alert("GUARDAR");
      }
      //B
      if (e.altKey && e.keyCode == 66) {
        alert("BORRAR");
      }
      //M
      if (e.altKey && e.keyCode == 77) {
        alert("MODIFICAR");
      }
    },
  },

  mounted() {
    document.title = "Resumen por Transportista";

    this.setTitleToolbar("Resumen por transportista");
    this.cargarDatos();
    this.cargarLista();
  },

  created() {
    document.onkeyup = this.onkeyup;
  },
};
</script>
